// src/IT/pages/ITChatbot.jsx
import React, { useRef, useState } from "react";
import { itChat } from "../../api/ITapi";

export default function ITChatbot() {
  const [msgs, setMsgs] = useState([
    { from: "bot", text: "Hi! Tell me what IT request you need (license/software/vm/laptop/hardware/research)." },
  ]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  const send = async () => {
    const m = text.trim();
    if (!m || busy) return;

    setMsgs((x) => [...x, { from: "me", text: m }]);
    setText("");
    setBusy(true);

    try {
      const res = await itChat(m);
      setMsgs((x) => [...x, { from: "bot", text: res.reply || "OK" }]);
      setTimeout(() => endRef.current?.scrollIntoView({ behavior: "smooth" }), 10);
    } catch (e) {
      setMsgs((x) => [...x, { from: "bot", text: `Error: ${e.message}` }]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="it-page">
      <div className="it-card">
        <div className="it-card-title">IT Chatbot (Llama)</div>

        <div className="it-chatbox">
          {msgs.map((m, idx) => (
            <div key={idx} className={`it-bubble ${m.from === "me" ? "me" : "bot"}`}>
              {m.text}
            </div>
          ))}
          <div ref={endRef} />
        </div>

        <div className="it-row" style={{ marginTop: 10 }}>
          <input
            className="it-chatinput"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Type your request…"
            onKeyDown={(e) => (e.key === "Enter" ? send() : null)}
          />
          <button className="it-btn-sm" onClick={send} disabled={busy}>
            {busy ? "..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
}
